import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { resourceFromAttributes } from '@opentelemetry/resources';

// REACT_APP_UCAUTH_BASE_PROTO must include the trailing "://" (e.g. "https://")
const apiOrigin = process.env.REACT_APP_UCAUTH_BASE_PROTO && process.env.REACT_APP_UCAUTH_BASE_HOST
    ? `${process.env.REACT_APP_UCAUTH_BASE_PROTO}${process.env.REACT_APP_UCAUTH_BASE_HOST}`
    : window.location.origin;

const provider = new WebTracerProvider({
    resource: resourceFromAttributes({ 'service.name': 'ucauth-identity-frontend' }),
    // No span processors — spans are created but not exported anywhere
});

provider.register({
    propagator: new W3CTraceContextPropagator(),
});

registerInstrumentations({
    instrumentations: [
        new FetchInstrumentation({
            propagateTraceHeaderCorsUrls: [new RegExp(apiOrigin.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))],
        }),
    ],
});
